import { render } from "./CompanyTeam.vue?vue&type=template&id=50f05768&scoped=true&ts=true"
import script from "./CompanyTeam.vue?vue&type=script&lang=ts"
export * from "./CompanyTeam.vue?vue&type=script&lang=ts"

import "./CompanyTeam.vue?vue&type=style&index=0&id=50f05768&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f05768"]])

export default __exports__